// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2L91d","rightAdornment":"Header_rightAdornment__35Prg"};